<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">New Claims Advice</h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="loading-overlay" v-if="loading"></div>
          <table class="table carpenter">
            <thead>
              <tr>
                <th>Claim Reference</th>
                <th>Client Name</th>
                <th v-if="hasAgent">Managed By Agent</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody v-if="incidents.length">
              <tr v-bind:key="index" v-for="(incident, index) in incidents">
                <td>
                  {{
                    incident.source
                      ? incident.source.claim_reference
                        ? incident.source.claim_reference
                        : 'Not Provided'
                      : 'Not Provided'
                  }}
                </td>
                <td>
                  {{
                    incident.client
                      ? incident.client.full_name
                        ? incident.client.full_name
                        : 'Not Provided'
                      : 'Not Provided'
                  }}
                </td>
                <td v-if="hasAgent">
                  <span
                    class="label label-primary"
                    v-if="incident.manager_name === 'Agent'"
                    >Yes</span
                  >
                  <span class="label label-warning" v-else>No</span>
                </td>
                <td class="text-right">
                  <button
                    class="btn btn-primary"
                    v-on:click.prevent="viewIncident(incident)"
                  >
                    View New Claims Advice
                  </button>
                </td>
              </tr>
            </tbody>
            <tbody v-if="!incidents.length">
              <tr>
                <td colspan="3" class="text-center">
                  There are currently no claims in New Claims Advice
                </td>
              </tr>
            </tbody>
          </table>
          <div class="card-footer text-right" v-show="showPagination">
            <pagination
              :data="paginator_data"
              v-on:updateResults="getData"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './../Shared/PageHeader.vue';

export default {
  components: {
    PageHeader
  },

  data() {
    return {
      loading: false,
      incidents: [],
      paginator_data: {}
    };
  },

  mounted() {
    this.findIncidents();
  },

  computed: {
    hasAgent() {
      return false;
      // return !! this.$store.getters.agent;
    },

    showPagination() {
      return (
        this.paginator_data.next_page_url || this.paginator_data.prev_page_url
      );
    }
  },

  methods: {
    getData(url) {
      window.Ajax.get(url)
        .then(response => {
          this.incidents = response.data.data;
          this.paginator_data = response.data;
        })
        .catch(error => {});
    },

    viewIncident(incident) {
      this.$router.push('/new-claims-advice/' + incident.identifier);
    },

    findIncidents() {
      this.getData(
        `/incidents?filter[stage]=new_claims_advice&per_page=${this.perPage}`
      );
    }
  }
};
</script>
